import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-branding-asset-field',
  standalone: true,
  template: `
    <div class="branding-asset-field">
      <div class="branding-asset-field__hint">{{ hint }}</div>
      <input
        type="file"
        [accept]="accept"
        [disabled]="disabled"
        (change)="selected.emit($event)"
      />
      @if (selectedName) {
        <div class="branding-asset-field__meta">Selected: {{ selectedName }}</div>
      }
      <div class="branding-asset-field__actions">
        <button
          type="button"
          class="branding-asset-field__action branding-asset-field__action--primary"
          [disabled]="!hasSelected || disabled"
          (click)="upload.emit()"
        >
          {{ isUploading ? 'Uploading...' : uploadLabel }}
        </button>
        @if (assetUrl) {
          <button
            type="button"
            class="branding-asset-field__action"
            [disabled]="disabled"
            (click)="remove.emit()"
          >
            {{ isRemoving ? 'Removing...' : removeLabel }}
          </button>
        }
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .branding-asset-field {
      display: grid;
      gap: 8px;
    }

    .branding-asset-field__hint {
      font-size: 12px;
      line-height: 1.45;
      color: #6b7280;
    }

    .branding-asset-field__meta {
      color: #6b7280;
      font-size: 13px;
    }

    .branding-asset-field__actions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .branding-asset-field__action {
      min-height: 36px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      background: #ffffff;
      color: #1f2937;
      padding: 0 12px;
      cursor: pointer;
    }

    .branding-asset-field__action--primary {
      border-color: #2563eb;
      background: #2563eb;
      color: #ffffff;
    }

    .branding-asset-field__action:disabled {
      opacity: 0.55;
      cursor: default;
    }

    @media (max-width: 900px) {
      .branding-asset-field__action {
        width: 100%;
      }
    }
  `],
})
export class BrandingAssetFieldComponent
{
  @Input() public hint = '';
  @Input() public selectedName = '';
  @Input() public assetUrl: string | null = null;
  @Input() public hasSelected = false;
  @Input() public disabled = false;
  @Input() public isUploading = false;
  @Input() public isRemoving = false;
  @Input() public uploadLabel = 'Upload';
  @Input() public removeLabel = 'Remove';
  @Input() public accept = 'image/png,image/jpeg,image/webp,image/gif,image/svg+xml';

  @Output() public readonly selected = new EventEmitter<Event>();
  @Output() public readonly upload = new EventEmitter<void>();
  @Output() public readonly remove = new EventEmitter<void>();
}
